<script>
import CityInfo from '@/components/CityInfo'
import IconTile from '@/components/IconTile'
import ChatBubble from '@/components/ChatBubble'
import AlertBubble from '@/components/AlertBubble'
import DialogUtils from '@/utils/dialogUtils'
import EnvironmentUtils from '@/utils/environmentUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import WeatherService from '@/services/weather'
import ActualitiesServices from '@/services/actualities'
import EventsServices from '@/services/events'
import UsefulInfoServices from '@/services/usefulInfo'
import NewslettersServices from '@/services/newsletters'
import NotificationsServices from '@/services/notifications'
import LoyaltyCardFrame from '@/frames/loyaltyCardFrame'
import StoreFrame from '@/frames/storeFrame'
import LostPetsFrame from '@/frames/lostPetsFrame'
import LostObjectsFrame from '@/frames/lostObjectsFrame'
import ReportsFrame from '@/frames/reportsFrame'
const REF_TILES_CONTAINER = 'tiles-container'

export default
{
    name: 'home',

    async created ()
    {
        const cityId = EnvironmentUtils.cityId
        const token = this.$store.state.user.token || LocalStorageUtils.token

        if (token)
        {
            await this.$store.dispatch('user/fetchUserInformationFromToken', {token, cityId})
        }
        
        this.$store.commit('weather/setCityWeather', await WeatherService.fetchCityWeather(cityId))
        
        // Prefetching data that may be used later.
        ActualitiesServices.fetchActualities(cityId, null, {from: 0, number: 30, excludeContent: true}).then(actualities =>
        {
           this.$store.commit('actualities/updateActualityList', actualities)
        })
        EventsServices.fetchEvents(cityId).then(events  =>
        {
            this.$store.commit('events/updateEventList', events)
        })

        UsefulInfoServices.fetchInfos(cityId).then(infos  =>
        {
            this.$store.commit('usefulInfos/updateInfoList', infos)
        })
        NotificationsServices.fetchSentPushNotifications(cityId).then(notifications =>
        {
            this.$store.commit('notifications/setSentPushNotifications', notifications)
        })
        
        // CovidServices.getCovidHelp(EnvironmentUtils.cityId).then(help =>
        // {
        //     this.$store.commit('covid/setCovidHelp', help)
        // })
        // CovidServices.getHealthStatsForDate(DateUtils.add(new Date(), {days: -4})).then(D2stats =>
        // {
        //     this.$store.commit('covid/updateHealthStats', D2stats)
        // })
        // CovidServices.getHealthStatsForDate(DateUtils.add(new Date(), {days: -2})).then(D2stats =>
        // {
        //     this.$store.commit('covid/updateHealthStats', D2stats)
        // })
        // CovidServices.getHealthStatsForDate(DateUtils.add(new Date(), {days: -1})).then(D1Stats =>
        // {
        //     this.$store.commit('covid/updateHealthStats', D1Stats)
        // })

        LoyaltyCardFrame.initFrame(this.$store)
        StoreFrame.initFrame(this.$store)
        LostPetsFrame.initFrame(this.$store)
        ReportsFrame.initFrame(this.$store, 'pending')
        LostObjectsFrame.initFrame(this.$store)
    },

    render () 
    {
        const uA = this.unseenActualities.length
        const uE = this.unseenEvents.length
        const pO = this.publishedLostObjects.length
        const lP = this.publishedLostPets.length
        const greetingMessage = EnvironmentUtils.cityFeatures.greetingMessage

        return (
            <div id='home-view'>
                <CityInfo />
                <div id='content-body'>
                    <alert-bubble v-show={greetingMessage} alert-id={'greeting-message:'+greetingMessage}>{greetingMessage}</alert-bubble>
                    <div id='tiles-container' ref={REF_TILES_CONTAINER}>
                        <IconTile on-click={() => this.tileClicked('actualities')} title={'actualités'} description={`${uA} non lue${uA > 1 ? 's' : ''}`}
                            icon={require('@/assets/img/newspaper.svg')} />
                        <IconTile on-click={() => this.tileClicked('events')} title={'événements'} description={`${uE} non lu${uE > 1 ? 's' : ''}`}
                            icon={require('@/assets/img/calendar.svg')} />
                        <IconTile v-show={EnvironmentUtils.cityFeatures.hasLoyaltyCard} on-click={() => this.tileClicked('loyalty-card')}
                            title={'Ma carte'} description={`Vous avez ${this.$store.getters.loyaltyCard.getCumuledBalance} points`} icon={require('@/assets/img/card.svg')} />
                        <IconTile v-show={EnvironmentUtils.cityFeatures.hasStores} on-click={() => this.tileClicked('stores')} title={'mes commerces'}
                            description={''} icon={require('@/assets/img/store.svg')} />
                        <IconTile v-show={EnvironmentUtils.cityFeatures.hasReports} on-click={() => this.tileClicked('report')}
                            title={'faire un signalement'} description={''} icon={require('@/assets/img/alarm.svg')} />
                        <IconTile on-click={() => this.tileClicked('useful-info')} title={'informations utiles'} description={''}
                            icon={require('@/assets/img/agenda.svg')} />
                        <IconTile v-show={EnvironmentUtils.cityFeatures.hasLostObjects} on-click={() => this.tileClicked('lost-objects')}
                            title={'Objets perdus'} description={`${pO} objet${pO > 1 ? 's' : ''} publié${pO > 1 ? 's' : ''}`} icon={require('@/assets/img/objects-magnifier.svg')} />
                        <IconTile v-show={EnvironmentUtils.cityFeatures.hasLostPets} on-click={() => this.tileClicked('lost-pets')}
                            title={'Animaux perdus'} description={`${lP} publication${lP > 1 ? 's' : ''}`} icon={require('@/assets/img/girl-with-pet.png')} />
                        { 
                            /* 
                            <IconTile on-click={() => this.tileClicked('covid')}
                            title={'COVID-19'} description={`${this.covidDeltaInfections >= 0 ? '+' : ''}${this.covidDeltaInfections} cas dans ${EnvironmentUtils.cityDepartmentWithPronoun}`}
                            icon={require('@/assets/img/earth-virus.svg')} />
                            <IconTile on-click={() => this.devTileClicked('surveys')} title={'sondages'} description={'1 non fait'}
                            icon={require('@/assets/img/collective-rate.svg')} disabled={true} />
                        <IconTile on-click={() => this.devTileClicked('chat')} title={'Messagerie'} description={'0 message non lu'}
                            icon={require('@/assets/img/chat-bubble.svg')} disabled={true} />
                        <IconTile v-show={EnvironmentUtils.cityFeatures.hasProcedures} on-click={() => this.devTileClicked('procedures')}
                            title={'démarches'} description={'0 en attente'} icon={require('@/assets/img/folder.svg')} disabled={true} />
                        <IconTile v-show={EnvironmentUtils.cityFeatures.hasTransports} on-click={() => this.devTileClicked('transports')}
                            title={'transports'} description={''} icon={require('@/assets/img/ticket.svg')} disabled={true} /> 
                        <IconTile v-show={EnvironmentUtils.cityFeatures.hasWeather} on-click={() => this.devTileClicked('weather')}
                            title={'météo'} description={'Partiellement nuageux, 20 °C'} icon={require('@/assets/img/thermostat.svg')} /> 
                            */
                        }
                    </div>
                </div>
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    computed:
    {
        unseenActualities ()
        {
            return this.$store.state.actualities.actualityList.filter(a => !LocalStorageUtils.actualitiesSeen.includes(a.id))
        },

        unseenEvents ()
        {
            return this.$store.state.events.eventList.filter(e => !LocalStorageUtils.eventsSeen.includes(e.id))
        },

        publishedLostObjects ()
        {
            return this.$store.state.lostObjects.objectsList.filter(o => o.tags.includes('published'))
        },
        publishedLostPets ()
        {
            return this.$store.state.lostPets.petsList.filter(o => o.tags.includes('published'))
        },

        covidDeltaInfections ()
        {
            const stats = this.$store.getters.covid.getHealthStatsForZipcode(EnvironmentUtils.cityZipcode)
            const d1Stats = Object.values(stats).filter(d => d)[0]

            if (!d1Stats || !d1Stats.nouvellesHospitalisations) return 0

            return d1Stats.nouvellesHospitalisations
        }
    },

    methods:
    {
        tileClicked (tileName)
        {
            this.$router.push(`/${tileName}`)
        },

        devTileClicked (tileName)
        {
            const subscribeToNewsLetterClicked = async (e, chatBubble) =>
            {
                chatBubble.close()
                const email = await DialogUtils.promptAsync({ title: 'S\'inscrire à la newsletter', placeholder: 'Votre courriel' })
                if (!email) return

                console.log('Subscribing', email, 'to newsletter')
                try
                {
                    const response = await NewslettersServices.subscribe(email, EnvironmentUtils.cityId, 'work-in-progress-tile')
                    console.log('User successfully subcribed to newsletter', response)
                    this.$toast.success('Vous avez été inscrit à la newsletter')
                }
                catch (e)
                {
                    console.error('User', email, 'suscription to newsletter has failed', e)
                }
            }

            const propsData =
            {
                message: 'Cette fonctionnalité est en plein développement ! Elle sera bientôt disponible 🙂',
                buttons:
                [
                    { label: 'Me tenir informé du développement', action: subscribeToNewsLetterClicked, type: 'primary'  }
                ]
            }
            DialogUtils.showChatBubble(propsData)
        }
    },

    components:
    {
        CityInfo,
        IconTile,
        ChatBubble,
        AlertBubble
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#home-view
{
    margin-bottom: 10vh;

    .OnDesktop({
        margin-bottom: unset;
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
    });

    #content-body
    {
        margin: 27vh 4vw 0 4vw;

        .OnSmallMobile({ margin-top: 28vh; });
        .OnLargeMobile({ margin-top: 24vh; });

        #tiles-container
        {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 5vw;

            .OnTablet({
                grid-template-columns: repeat(3, 1fr);
                grid-gap: 4vw;
            });

            .OnDesktop({
                grid-template-columns: repeat(5, 1fr);
                grid-gap: 2vw;
            });

            .OnLarge({
                grid-template-columns: repeat(6, 1fr);
                margin-right: 10vw;
            });

            .icon-tile
            {
                padding: 15% 10% 10% 10%;

                .icon
                {
                    filter: drop-shadow(var(--theme-box-shadow-icon));
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue